import React, { FunctionComponent, useCallback } from 'react'
import { t } from '@lingui/macro'
import { useImportMappingOptions } from '../../hooks/useImportMappingOptions'
import { OnFieldMappingReplace } from '../../types/FieldsMappingTypes'
import { Select } from 'front-end/src/components'

export interface IImportMappingSelectorProps {
  onSelect: OnFieldMappingReplace
  selectedId?: number
  columnsCount: number
}
export const ImportMappingSelector: FunctionComponent<IImportMappingSelectorProps> =
  ({ onSelect, selectedId, columnsCount }) => {
    const { options, getMapping } = useImportMappingOptions(columnsCount)

    const allOptions = [{ value: '', label: t`New mapping` }, ...options]

    const onChange = useCallback(
      (newValue: string) => {
        if (!newValue) {
          onSelect(undefined)
          return
        }

        const mapping = getMapping(parseInt(newValue, 10))

        if (!mapping) {
          throw new Error('Selected mapping is not suitable for uploaded file')
        }

        onSelect(mapping)
      },
      [getMapping]
    )

    return (
      <Select
        fullWidth
        options={allOptions}
        defaultValue={allOptions[0]}
        value={allOptions.find(({ value }) => {
          return value === (selectedId || '')
        })}
        onChange={(v) => onChange(v?.value)}
      />
    )
  }
